// extracted by mini-css-extract-plugin
export default {"container":"product-category-select_container__PWMJW","select":"product-category-select_select__14X81"};